
// Admin Emails
export const GET_EMAILS = "GET_EMAILS";
export const FETCH_SINGLE_EMAIL = "FETCH_SINGLE_EMAIL";
export const DELETE_SINGLE_EMAIL = "DELETE_SINGLE_EMAIL";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const CREATE_ADMIN_EMAIL = "CREATE_ADMIN_EMAIL";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const USER_LOADED = "USER_LOADED";

// admin categories
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SINGLE_CATEGORY = "GET_SINGLE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";

// Marketing Material
export const GET_MARKETING_BANNERS = "GET_MARKETING_BANNERS";
export const CREATE_MARKETING_BANNER = "CREATE_MARKETING_BANNER";
export const GET_SINGLE_MARKETING_BANNER = "GET_SINGLE_MARKETING_BANNER";
export const UPDATE_MARKETING_BANNER = "UPDATE_MARKETING_BANNER";
export const DELETE_MARKETING_BANNER = "DELETE_MARKETING_BANNER";

// Wocommerce Pricing
export const GET_WOCOMMERCE = "GET_WOCOMMERCE";
export const CREATE_WOCOMMERCE = "CREATE_WOCOMMERCE";
export const GET_SINGLE_WOCOMMERCE = "GET_SINGLE_WOCOMMERCE";
export const UPDATE_WOCOMMERCE = "UPDATE_WOCOMMERCE";
export const DELETE_WOCOMMERCE = "DELETE_WOCOMMERCE";

// Shopify Pricing
export const GET_SHOPIFY = "GET_SHOPIFY";
export const CREATE_SHOPIFY = "CREATE_SHOPIFY";
export const GET_SINGLE_SHOPIFY = "GET_SINGLE_SHOPIFY";
export const UPDATE_SHOPIFY = "UPDATE_SHOPIFY";
export const DELETE_SHOPIFY = "DELETE_SHOPIFY";

// Wix Pricing
export const GET_WIX = "GET_WIX";
export const CREATE_WIX = "CREATE_WIX";
export const GET_SINGLE_WIX = "GET_SINGLE_WIX";
export const UPDATE_WIX = "UPDATE_WIX";
export const DELETE_WIX = "DELETE_WIX";

// Cart Pricing
export const GET_CART = "GET_CART";
export const CREATE_CART = "CREATE_CART";
export const GET_SINGLE_CART = "GET_SINGLE_CART";
export const UPDATE_CART = "UPDATE_CART";
export const DELETE_CART = "DELETE_CART";


export const UPLOAD_BANNER = "UPLOAD_BANNER";
// errors and success
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const SET_ALERT = "SET_ALERT";

export const LOG_OUT = "LOG_OUT";

// errors and success
export const GET_SETTING = "GET_SETTING";
export const UPDATE_SETTING = "UPDATE_SETTING";

export const GET_WIX_MERCHANTS = "GET_WIX_MERCHANTS";
export const GET_WP_MERCHANTS = "GET_WP_MERCHANTS";
export const GET_SHOPIFY_MERCHANTS = "GET_SHOPIFY_MERCHANTS";

export const GET_SINGLE_WIX_MERCHANT = "GET_SINGLE_WIX_MERCHANT";
export const GET_SINGLE_WP_MERCHANT = "GET_SINGLE_WP_MERCHANT";
export const GET_SINGLE_BC_MERCHANT = "GET_SINGLE_BC_MERCHANT";

export const UPDATE_WIX_MERCHANT = "UPDATE_WIX_MERCHANT";
export const UPDATE_WP_MERCHANT = "UPDATE_WP_MERCHANT";
export const UPDATE_BC_MERCHANT = "UPDATE_BC_MERCHANT";

export const GET_BIGCOMMERCE_MERCHANTS = "GET_BIGCOMMERCE_MERCHANTS";
export const GET_PORTAL_MERCHANTS = "GET_PORTAL_MERCHANTS";

export const CREATE_PORTAL_MERCHANT = "CREATE_PORTAL_MERCHANT";
export const GET_SINGLE_PORTAL_MERCHANT = "GET_SINGLE_PORTAL_MERCHANT";
export const UPDATE_PORTAL_MERCHANT = "UPDATE_PORTAL_MERCHANT";
export const DELETE_PORTAL_MERCHANT = "DELETE_PORTAL_MERCHANT";

export const SEND_EMAIL = "SEND_EMAIL";

export const RESET_LOADING = "RESET_LOADING";

export const GET_SMTP_DETAILS="GET_SMTP_DETAILS";

// wix categories
export const GET_WIX_CATEGORIES = "GET_WIX_CATEGORIES";
export const GET_SINGLE_WIX_CATEGORY = "GET_SINGLE_WIX_CATEGORY";

// wocommerce categories
export const GET_WOCOMM_CATEGORIES = "GET_WIX_CATEGORIES";
export const GET_SINGLE_WOCOMM_CATEGORY = "GET_SINGLE_WOCOMM_CATEGORY";

// fetch activities
export const FETCH_ACTIVITIES = "FETCH_ACTIVITIES";

// popup content
export const GET_POPUP_CONTENT = "GET_POPUP_CONTENT";
export const UPDATE_POPUP_CONTENT = "UPDATE_POPUP_CONTENT";

// home page banner content
export const GET_HOME_PAGE_BANNERS = "GET_HOME_PAGE_BANNERS";
